import useCodingProfileDelete from 'api/codingProfile/useCodingProfileDelete/useCodingProfileDelete';
import useCodingProfileList from 'api/codingProfile/useCodingProfileLiset/useCodingProfileLiset';
import DeleteModal from 'components/shared/DeleteModal/DeleteModal';
import CodingProfileEditModal from 'components/shared/Modals/codingProfile/CodingProfileEditModal/CodingProfileEditModal';
import CodingProfileInsertModal from 'components/shared/Modals/codingProfile/CodingProfileInsertModal/CodingProfileInsertModal';
import CodingProfileMappingModal from 'components/shared/Modals/codingProfile/CodingProfileMappingModal/CodingProfileMappingModal';
import ApiPaginateTable from 'components/shared/Table/ApiPaginateTable';
import useCodingProfileTableColumns from 'hooks/codingProfile/useCodingProfileTableColumns';
import { permissions } from 'hooks/permissions/permissions';
import { usePermissions } from 'hooks/permissions/usePermissions';
import axiosClient from 'lib/axiosClient';
import { useSnackbar } from 'notistack';
import React, { useCallback, useEffect, useRef, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PageSpinner from '../../components/shared/pageSpinner/PageSpinner';

// last search string
let lastSearch = null;

const CodingProfile = () => {
  const { enqueueSnackbar } = useSnackbar();
  const [page, setPage] = useState(1);
  const [pageSize, setPageSize] = useState('100');
  const [getCodingProfileList, loading, codingProfileList, pageRef] =
    useCodingProfileList();

  const [isInsertModalOpen, setIsInsertModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [deleteChosenLocation, setDeleteChosenLocation] = useState({});
  const [deleteLoading, setDeleteLoading] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [editChosenCode, setEditChosenCode] = useState({});

  const [showMappingModal, setShowMappingModal] = useState(false);
  const [mappingProfileData, setMappingProfileData] = useState([]);

  const navigate = useNavigate();
  const tableRef = useRef(null);
  const [deleteRequest] = useCodingProfileDelete();
  const { can } = usePermissions();

  const profileGroupPermissions =
    permissions.general.categories.globalSettings.coddingSettings.profileGroup;
  const mappingProfilePermissions =
    permissions.general.categories.globalSettings.coddingSettings
      .mappingProfile;

  const canCreate = can(profileGroupPermissions.create);
  const canEdit = can(profileGroupPermissions.edit);
  const canDelete = can(profileGroupPermissions.delete);
  const canDetail = can(profileGroupPermissions.detail);
  const canEditMapping = can(mappingProfilePermissions.edit);

  useEffect(() => {
    getCodingProfileList({ page: 1, count: pageSize });
  }, []);

  useEffect(() => {
    getCodingProfileList({ page, count: pageSize });
  }, [pageSize]);

  useEffect(() => {
    if (!canEdit) {
      return;
    }

    axiosClient
      .get(`/SettingProduct/MappingProfile/GetAll`)
      .then(mapData => {
        if (mapData) {
          setMappingProfileData(mapData.data?.value);
        }
      })
      .catch(() => {
        enqueueSnackbar('خطا در دریافت لیست', { variant: 'error' });
      });
  }, [canEdit, enqueueSnackbar]);

  const goToGroupPage = useCallback(
    id => {
      navigate(`/coding-groups-list/${id}`);
    },
    [navigate],
  );

  const openMapping = useCallback(id => setShowMappingModal(true), []);

  const deleteItem = useCallback(
    row => () => {
      setDeleteChosenLocation(row);
      setIsDeleteModalOpen(true);
    },
    [],
  );

  const editItem = useCallback(
    row => () => {
      setEditChosenCode(row);
      setIsEditModalOpen(true);
    },
    [],
  );

  const closeMappingModal = () => {
    setShowMappingModal(false);
  };

  const [columnsData] = useCodingProfileTableColumns(
    goToGroupPage,
    openMapping,
    deleteItem,
    editItem,
    tableRef,
    {
      canDetail,
      canEdit,
      canDelete,
      canEditMapping,
    },
  );

  const deleteHandle = id => {
    setDeleteLoading(true);
    deleteRequest(
      id,
      getCodingProfileList,
      setIsDeleteModalOpen,
      setDeleteLoading,
    );
  };

  function getPageData(pageNumber) {
    setPage(pageNumber);
    getCodingProfileList({
      page: pageNumber,
      count: pageSize,
      term: lastSearch,
    });
  }

  function handleSearch(text) {
    setPage(1);
    lastSearch = text;
    if (text === '') {
      lastSearch = null;
    }
    getCodingProfileList({ page: 1, count: pageSize, term: text });
  }

  return (
    <>
      <div>{pageRef.refTitle}</div>

      {Object.keys(codingProfileList).length !== 0 ? (
        <ApiPaginateTable
          columns={columnsData}
          rowsData={codingProfileList[page]}
          rows={codingProfileList[page]}
          pageSize={pageSize}
          isDeletable={canDelete}
          isLoading={loading}
          addLable={canCreate ? 'ثبت کد پروفایل' : undefined}
          onAddClick={canCreate ? () => setIsInsertModalOpen(true) : undefined}
          setPageSize={val => setPageSize(val)}
          apiRef={tableRef}
          onPageChange={p => getPageData(p)}
          page={page}
          countPages={
            pageRef?.totalCount ? Math.ceil(pageRef.totalCount / pageSize) : 1
          }
          handleSearchApi={handleSearch}
        />
      ) : (
        <PageSpinner loading />
      )}

      {canDelete ? (
        <DeleteModal
          open={isDeleteModalOpen}
          handleClose={() => setIsDeleteModalOpen(false)}
          title={deleteChosenLocation.title}
          locationId={deleteChosenLocation.id}
          deleteLoading={deleteLoading}
          onDelete={deleteHandle}
        />
      ) : null}

      {canCreate ? (
        <CodingProfileInsertModal
          open={isInsertModalOpen}
          handleClose={() => setIsInsertModalOpen(false)}
          getCodingProfileList={getCodingProfileList}
        />
      ) : null}

      {canEdit ? (
        <CodingProfileEditModal
          open={isEditModalOpen}
          handleClose={() => setIsEditModalOpen(false)}
          chosenBasket={editChosenCode}
          getCodingProfileList={getCodingProfileList}
        />
      ) : null}

      {canEdit ? (
        <CodingProfileMappingModal
          typeData={mappingProfileData}
          reFetch={() => getCodingProfileList({ page, count: pageSize })}
          open={showMappingModal}
          handleClose={closeMappingModal}
        />
      ) : null}
    </>
  );
};

export default CodingProfile;
